export const getInitialState = () => ({
    /** 다이얼로그 정보 */
    dialogDetail: {
        userInfo: null,
    },
    /** 오리진 데이터 */
    originData: [],
    /** 사용자 권한 목록 */
    userPermissionList: [],
});
const states = getInitialState();
export default states;
